(function () {
  function initPdpMarquees(root) {
    if (typeof window.initMarquee !== 'function') return;

    var scope = root || document;
    var marquees = scope.querySelectorAll('.pdp-marquee-init');

    marquees.forEach(function (el) {
      window.initMarquee('.section--' + el.dataset.sectionId + ' .pdp_logos_texts_marquee_marquee', {
        mobile: { duration: 60000, gap: 0, duplicated: true, direction: 'left' },
        desktop: { duration: 60000, gap: 0, duplicated: true, direction: 'left' }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initPdpMarquees(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initPdpMarquees(event.target || document);
  });
})();
